import {
  InjectedModalProps,
  ModalContainer,
  ModalTitle,
  useMatchBreakpoints,
  CloseIcon,
  Text,
  Flex,
  IconButton,
  Button,
  Input,
  Box,
} from '@noahswap/uikit'
import { useTranslation } from '@noahswap/localization'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { CurrencyAmount, ChainId, Token } from '@noahswap/sdk'
import styled from 'styled-components'
import { useWeb3React } from '@noahswap/wagmi'
import Column, { AutoColumn, ColumnCenter } from 'components/Layout/Column'
import Row, { RowFixed, RowBetween } from 'components/Layout/Row'
import { useState, useCallback, KeyboardEvent, useRef, RefObject, useEffect } from 'react'
import MenuItem from '@noahswap/uikit/src/components/MenuItem/MenuItem'
import { CurrencyLogo } from 'components/Logo'
import { DEFAULT_ACTIVE_LIST_URLS } from 'config/constants/lists'
import CircleLoader from 'components/Loader/CircleLoader'
import { getGuageCoinList, getRecommendCoin } from 'service/service'
import chainUtils from 'service/chainUtils'
import { useRouter } from 'next/router'
import useDebounce from 'hooks/useDebounce'
import { useTokenBalances } from 'state/wallet/hooks'

export const ModalHeader = styled.div<{ background?: string }>`
  align-items: center;
  background: transparent;
  display: flex;
  padding: 12px 24px;
`

export const ModalBody = styled(Flex)`
  align-items: center;
  background: transparent;
  display: flex;
  /* padding: 100px 24px 60px; */
  justify-content: center;
  flex-direction: column;
`
const CoinScroll = styled.div`
  width: 100%;
  height: 250px;
  overflow: auto;
  padding-right: 15px;
`
const ListItem = styled(RowBetween)<{ disabled?: boolean; selected?: boolean }>`
  padding: 4px 0;
  height: 56px;
  display: grid;
  grid-template-columns: auto minmax(auto, 1fr) minmax(0, 72px);
  grid-gap: 8px;
  cursor: ${({ disabled }) => !disabled && 'pointer'};
  pointer-events: ${({ disabled }) => disabled && 'none'};
  :hover {
    background-color: ${({ theme, disabled }) => !disabled && theme.colors.background};
  }
  opacity: ${({ disabled, selected }) => (disabled || selected ? 0.5 : 1)};
`
const CoinModal = ({ onDismiss, setCoin }: any) => {
  const { isMobile } = useMatchBreakpoints()
  const { t } = useTranslation()
  const [searchQuery, setSearchQuery] = useState<string>('')
  const inputRef = useRef<HTMLInputElement>()
  const router = useRouter()
  // const parsedQueryChainId = Number(router.query.chainId)
  // const chainId = parsedQueryChainId || Number(localStorage.getItem('chainId')) || 17777
  // const { chainId } = useActiveWeb3React()
  const [listData, setListData] = useState<any>([])
  const { account } = useWeb3React()
  const [voteAddress, setVoteAddress] = useState<any>({})
  const [tokenList, setTokenList] = useState<any>([])
  const debouncedQuery = useDebounce(searchQuery, 200)
  // const handleEnter = useCallback((e: KeyboardEvent<HTMLInputElement>) => {
  //   if (e.key === 'Enter') {
  //   }
  // }, [])

  let tokenLists = Object.values(useTokenBalances(account ?? undefined, listData))
  // if (debouncedQuery) {
  //   if (account) {
  //     tokenLists = tokenLists.filter((v) => v?.currency?.symbol.indexOf(debouncedQuery.toUpperCase()) > -1)
  //   } else {
  //     tokenLists = listData.filter((v) => v?.currency?.symbol.indexOf(debouncedQuery.toUpperCase()) > -1)
  //   }
  // }
  if (!account) {
    tokenLists = listData.map((v) => {
      return CurrencyAmount.fromRawAmount(v, 0)
    })
  }
  console.log(tokenLists, 'tokenLists')
  console.log(listData, 'listData')
  const fetch = async () => {
    const { baseURL, chainid } = chainUtils()
    const { data, code } = await getGuageCoinList({ baseURL, chainid })
    // const { data, code } = await getRecommendCoin({ baseURL, chainid })
    let formatData = []
    if (!code) {
      formatData =
        data?.map((v) => {
          const vv = v
          const { decimal } = vv
          delete vv.decimal
          return {
            chainId: vv.chain_id,
            address: vv.contract,
            decimals: decimal,
            symbol: vv.symbol,
            name: vv.name,
            logoURI: 'aaa',
          }
        }) || []
      const listDatas = formatData.map((v: any) => {
        const value: any = Object.values(v)
        // @ts-ignore
        return new Token(...value)
      })
      // console.log(listDatas, 'listDatas')
      setListData(listDatas)
    }
  }
  const handleSetCoin = (item) => {
    setCoin(item)
    onDismiss()
  }

  useEffect(() => {
    // if (!account) return
    fetch()
  }, [account])

  // useEffect(() => {
  //   let copyTokenLists = tokenLists
  //   if (debouncedQuery) {
  //     copyTokenLists = copyTokenLists.filter((v) => v?.currency?.symbol.indexOf(debouncedQuery.toUpperCase()) > -1)
  //   }
  //   setTokenList(copyTokenLists)
  // }, [debouncedQuery, tokenLists])
  return (
    <ModalContainer $minWidth={isMobile ? '100%' : '418px'} $minHeight={!isMobile ? '300px' : 'auto'}>
      <Box style={{ width: isMobile ? '100% ' : '418px', height: !isMobile ? 'auto' : 'auto' }}>
        <ModalHeader>
          {/* 选择币种 */}
          <ModalTitle style={{ fontSize: '20px', fontWeight: '500' }}>{t('noah142')}</ModalTitle>
          <IconButton variant="text" onClick={onDismiss}>
            <CloseIcon width="24px" color="#000" />
          </IconButton>
        </ModalHeader>
        <ModalBody>
          <AutoColumn style={{ width: '90%' }}>
            <Row style={{ border: '1px solid #F6F6F6', paddingLeft: '10px', borderRadius: '10px' }}>
              <img src="/images/small-img/icon3.png" width="20px" alt="" />
              <Input
                id="token-search-input"
                // 请输入代币或者粘贴地址
                placeholder={t('noah402')}
                scale="lg"
                autoComplete="off"
                value={searchQuery}
                type="text"
                ref={inputRef as RefObject<HTMLInputElement>}
                onChange={(event: any) => {
                  setSearchQuery(event.target.value)
                }}
                // onKeyDown={handleEnter}
                style={{ fontWeight: 400 }}
              />
            </Row>
          </AutoColumn>
          <Box
            style={{
              background: '#FAFAFA',
              width: '90%',
              borderRadius: '6px',
            }}
            padding="15px"
            my="16px"
            pr="0"
          >
            <Flex justifyContent="space-between" mb="10px" pr="15px">
              {/* 代币 */}
              <Text fontSize="12px" color="#85868A">
                {t('noah191')}
              </Text>
              {/* 余额 */}
              <Text fontSize="12px" color="#85868A">
                {t('noah312')}
              </Text>
            </Flex>
            <CoinScroll>
              {tokenLists.length > 0 ? (
                tokenLists?.map((v: any, i: any) => {
                  return (
                    <ListItem
                      // eslint-disable-next-line react/no-array-index-key
                      key={i}
                      onClick={() => {
                        handleSetCoin(v)
                      }}
                    >
                      <CurrencyLogo currency={v.currency} size="28px" style={{ marginRight: '6px' }} />
                      <Column>
                        <Text small bold>
                          {v.currency.symbol}
                        </Text>
                        <Text color="textSubtle" fontSize="12px" ellipsis maxWidth="200px">
                          {v.currency.name}
                        </Text>
                      </Column>
                      <RowFixed style={{ justifySelf: 'flex-end' }}>{v?.toSignificant()}</RowFixed>
                    </ListItem>
                  )
                })
              ) : (
                <Flex justifyContent="center" alignItems="center" flexDirection="column" style={{ height: '240px' }}>
                  <img src="/images/small-img/noData.png" alt="" width="64px" style={{ marginBottom: '10px' }} />
                  <Text color="textSubtle" textAlign="center">
                    {t('noah116')}
                  </Text>
                </Flex>
              )}
            </CoinScroll>
          </Box>
          <Text small mb="50px" textAlign="left" style={{ width: '90%' }} color="#92929B">
            {t('noah351')}
          </Text>
        </ModalBody>
      </Box>
    </ModalContainer>
  )
}
export default CoinModal
